/**
 * 兜底测试关：正式关卡模块（content/stages/stageN.js）缺失/加载失败时使用。
 * gameScene._loadStageModule 动态 import 失败即回落到本模块的 makeFallbackStage。
 */
import * as patterns from '../../game/patterns.js';

/** 兜底测试关素材表（正式关卡模块缺失时使用） */
const FALLBACK = [
  { mobs: ['s1_harpy', 's1_griffon', 's1_wisp'], boss: 's1_boss_stormlord', bossName: '积雨云之王' },
  { mobs: ['s2_fish', 's2_eel', 's2_shark'], boss: 's2_boss_kraken', bossName: '深渊克拉肯' },
  { mobs: ['s3_ship1', 's3_ship2', 's3_ship3'], boss: 's3_boss_furnace', bossName: '核心熔炉' },
  { mobs: ['s4_deathcap', 's4_spore', 's4_drake'], boss: 's4_boss_treant', bossName: '千年树人' },
  { mobs: ['s5_ghost', 's5_imp', 's5_wraith'], boss: 's5_boss_voideye', bossName: '虚无之眼' },
  { mobs: ['s6_star', 's6_eye', 's6_cacodemon'], boss: 's6_boss_starcore', bossName: '星尘核心' },
];

/** 内置测试关：3 波小怪 + 1 个 2 阶段 boss，验证关卡流全链路。 */
export function makeFallbackStage(idx) {
  const f = FALLBACK[idx] || FALLBACK[0];
  const mobScript = (speed, fireInterval) => (e, dt, ctx) => {
    e.y += speed * dt * 60;
    e.x += Math.sin(e.age * 2) * 36 * dt // 位移乘 dt*60 契约（0.6*60=36）;
    if (ctx.fireGate(e, fireInterval)) {
      const aim = Math.atan2(ctx.playerY - e.y, ctx.playerX - e.x);
      patterns.aimed(ctx.field, e.x, e.y, e.age, aim, { n: 1, speed: 2.5, color: 1 });
    }
  };
  return {
    id: `stage${idx + 1}-fallback`,
    name: `STAGE ${idx + 1} · 测试关`,
    bg: `bg${idx + 1}`,
    bgm: `bgm_stage${idx + 1}`,
    *script() {
      yield { say: '测试关：正式关卡脚本就位后将替换本关' };
      yield { wait: 1.5 };
      for (let w = 0; w < 3; w++) {
        const defs = [];
        for (let i = 0; i < 5; i++) {
          defs.push({
            x: 60 + i * 90, y: -20 - i * 30, hp: 6, r: 12,
            spriteKey: f.mobs[w % f.mobs.length], scoreValue: 200,
            script: mobScript(1.2 + w * 0.3, Math.max(0.8, 2 - w * 0.3)),
            drops: [{ type: i === 2 ? 'P' : 'POINT', weight: 1 }],
          });
        }
        yield { wave: defs };
        yield { clear: true };
        yield { wait: 1 };
      }
      yield { say: '警告：强大的气息接近了……' };
      yield { wait: 1 };
      yield {
        boss: {
          name: f.bossName, title: 'FALLBACK BOSS', spriteKey: f.boss, x: 240, y: 140,
          phases: [
            {
              name: '第一形态', spellCard: false, hp: 300, timeLimit: 60,
              update(b, dt, ctx) {
                b.x = 240 + Math.sin(b.age * 0.8) * 120;
                b._fireT = (b._fireT || 0) + dt;
                if (b._fireT >= 0.5) {
                  b._fireT = 0;
                  patterns.spread(ctx.field, b.x, b.y, b.age, b.aimAtPlayer(), { n: 5, speed: 2.2, color: 0 });
                }
              },
            },
            {
              name: '狂暴形态', spellCard: true, hp: 400, timeLimit: 45,
              update(b, dt, ctx) {
                b._fireT2 = (b._fireT2 || 0) + dt;
                if (b._fireT2 >= 0.35) {
                  b._fireT2 = 0;
                  patterns.ring(ctx.field, b.x, b.y, b.age, 0, { n: 16, speed: 1.8, offset: b.age, color: 3 });
                }
                b._aimT = (b._aimT || 0) + dt;
                if (b._aimT >= 2) {
                  b._aimT = 0;
                  patterns.aimed(ctx.field, b.x, b.y, 0, b.aimAtPlayer(), { n: 3, speed: 3, color: 1 });
                }
              },
            },
          ],
        },
      };
    },
  };
}
